export default "__VITE_ASSET__DfvrY$l7__"